import {
    apiRequest,
    riwayatPendidikanDetail
} from "../../../../../services/adapters/kepegawaian/riwayatPendidikanService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", riwayatPendidikanDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository